import classNames from 'classnames';
import React, { forwardRef, memo } from 'react';

import ImageBlock from '~/components/ImageBlock';

export interface VideoEmbedProps {
  img: string | undefined;
  src: string;
  title?: string;
  description?: string;
  className?: string;
  allow?: string;
  referrerPolicy?: React.IframeHTMLAttributes<HTMLIFrameElement>['referrerPolicy'];
  sandbox?: string;
  allowFullScreen?: boolean;
  loading?: 'eager' | 'lazy';
}

const VideoEmbed = forwardRef<HTMLIFrameElement, VideoEmbedProps>(
  (
    {
      img,
      src,
      title = '',
      description,
      className,
      allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
      referrerPolicy = 'strict-origin-when-cross-origin',
      sandbox = 'allow-scripts allow-same-origin allow-presentation allow-forms allow-pointer-lock',
      allowFullScreen = true,
      loading = 'lazy',
    },
    ref
  ) => {
    const hasSrc = Boolean(src);

    const prop = {
      props: {
        src: img as string,
        alt: 'Image',
      },
    };

    return (
      <div className={classNames('video-embed', className)}>
        <div className="video-embed__media" role="group" aria-label={title}>
          {hasSrc && (
            <iframe
              ref={ref}
              className="video-embed__frame"
              src={src}
              title={title}
              loading={loading}
              allow={allow}
              referrerPolicy={referrerPolicy}
              sandbox={sandbox}
              allowFullScreen={allowFullScreen}
            />
          )}
          {!hasSrc && img && (
            <ImageBlock
              aria-label="video unavailable"
              className="video-embed__placeholder"
              images={[prop]}
            />
          )}
        </div>

        <div className={classNames('video-embed__meta')}>
          {description && <p className="video-embed__desc">{description}</p>}
        </div>
      </div>
    );
  }
);

VideoEmbed.displayName = 'VideoEmbed';
export default memo(VideoEmbed);
